const KEYS = {
  user: '@phoenix_user',
};

const getStorage = (key) => {
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : '';
};

const setStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

const removeStorage = (key) => {
  localStorage.removeItem(key);
};

const removeAllStorage = () => {
  localStorage.clear();
};

const Storage = {getStorage, setStorage, removeStorage, removeAllStorage};

Storage.getUser = () => {
  return getStorage(KEYS.user);
};
Storage.setUser = (data) => {
  if (!data || !data.isAuthenticated) {
    removeAllStorage();
  }
  setStorage(KEYS.user, data);
};

export default Storage;
